module.exports = __webpack_public_path__ + "img/a4.ee0eccef.jpg";